/**
 * Human-readable detail for quote follow-up automation steps (admin UI).
 */

function formatChannelLine(channel, label) {
  if (!channel?.status) return null;
  let line = `${label}: ${channel.status}`;
  if (channel.to) line += ` → ${channel.to}`;
  if (channel.messageId) line += ` (id: ${channel.messageId})`;
  if (channel.error) line += ` (${channel.error})`;
  if (channel.reason) line += ` (${channel.reason})`;
  return line;
}

/**
 * @param {object} step - automation step from API
 * @returns {string}
 */
export function formatAutomationStepDetail(step) {
  const status = (step?.status || "").toLowerCase();
  if (status === "failed" && step.error) return step.error;
  if (status === "skipped" && step.skipReason) return step.skipReason;

  if (status !== "sent") return "";

  const parts = [];

  if (step.response?.channels) {
    const { whatsapp, email } = step.response.channels;
    const waLine = formatChannelLine(whatsapp, "WhatsApp");
    if (waLine) parts.push(waLine);
    const emailLine = formatChannelLine(email, "Email");
    if (emailLine) parts.push(emailLine);
  } else if (step.response?.success === true || step.response?.messageId) {
    // Legacy steps sent before normalized channels were stored
    parts.push("WhatsApp: sent");
    if (step.response.messageId) {
      parts.push(`Message id: ${step.response.messageId}`);
    }
  }

  if (parts.length === 0 && step.message) {
    const preview = String(step.message).trim().split("\n")[0];
    if (preview) {
      parts.push(
        preview.length > 120 ? `${preview.slice(0, 117)}…` : preview
      );
    }
  }

  return parts.join("\n");
}
